import { apiClient } from "../config/env";

// API 함수
export function login(params) {
  return apiClient.get(`/login`, { params });
}

export function authenticate() {
  return apiClient.get(`/authenticate`);
}

export function logout(data) {
  return apiClient.put(`/accounts/logout`, data);
}

export function fetchArtistList(params) {
  return apiClient.get(`/artist`, { params });
}

export function pwChange(data) {
  return apiClient.put(`/settings/user/pwchange`, data);
}
